import { DateTime } from "luxon";
import shortid from "shortid";

import { Availabilities, AvailabilitySlots } from "@/types/Availability";
import { getWeek, WeekDay } from "@/utils/getWeek";

// TODO refactor and add unit tests
export const serializeSlots = (slots: AvailabilitySlots) => {
  if (!slots) return [];
  const week = getWeek(new Date());

  return week.reduce((acc: Availabilities, val: WeekDay, idx: number) => {
    const { year, month, day } = val;
    return acc.concat(
      slots[idx + 1].map((slot) => {
        const [startH, startM] = slot.start.split(":");
        let [endH, endM] = slot.end.split(":");
        if (+endH === 0 && +endM === 0) {
          endH = "23";
          endM = "59";
        }
        return {
          id: shortid.generate(),
          start: DateTime.fromJSDate(new Date(year, month, day, +startH, +startM)).toISO(),
          end: DateTime.fromJSDate(new Date(year, month, day, +endH, +endM)).toISO(),
        };
      }),
    );
  }, []);
};
export const uniqBy = (arr: Availabilities[], predicate: string) => {
  const cb = typeof predicate === "function" ? predicate : (o: any) => o[predicate];

  return [
    ...arr
      .reduce((map, item) => {
        const key = item === null || item === undefined ? item : cb(item);

        map.has(key) || map.set(key, item);

        return map;
      }, new Map())
      .values(),
  ];
};

// TODO refactor and add unit tests
export const deserializeSlots = (slots: Availabilities) => {
  const availabilitySlots: AvailabilitySlots = { "1": [], "2": [], "3": [], "4": [], "5": [], "6": [], "7": [] };
  slots.forEach(({ start, end }) => {
    const parsedStart = new Date(start);
    const parsedEnd = new Date(end);
    const startDateTime = DateTime.fromJSDate(parsedStart);
    const endDateTime = DateTime.fromJSDate(parsedEnd);
    const day = startDateTime.weekday;
    const slot = {
      start: startDateTime.toFormat("HH:mm"),
      end: endDateTime.toFormat("HH:mm"),
    };
    availabilitySlots[`${day}`].push(slot);
  });
  return availabilitySlots;
};

export const getWeekends = (slots: AvailabilitySlots) => {
  if (!slots) return [];
  return Object.keys(slots).reduce((acc: string[], val) => (slots[val].length ? acc : [...acc, val]), []);
};
